import { ACTIVATOR_KEY_REGEX } from './ShortcutProvider.consts';

export const isValidActivatorKey = (keyCode: string) => {
  return ACTIVATOR_KEY_REGEX.test(keyCode);
};

export const isTargetInMuiPopoper = (target: HTMLElement | null) => {
  // Check if the event target is within a Popover, Modal, or Menu
  // Specifically for the MUI components popover when connecting a calendar entity
  return (
    target?.closest('.MuiPopover-root') ||
    target?.closest('.MuiModal-root') ||
    target?.closest('.MuiMenu-root')
  );
};
